export type ImpersonationOrigin = 'client' | 'management' | 'admin';

export const IMPERSONATION_ORIGIN_STORAGE_KEY = 'impersonationOrigin';

function getStorage(storage?: Storage): Storage | null {
  if (storage) {
    return storage;
  }

  return typeof localStorage !== 'undefined' ? localStorage : null;
}

export function getImpersonationOrigin(storage?: Storage): ImpersonationOrigin | null {
  const value = getStorage(storage)?.getItem(IMPERSONATION_ORIGIN_STORAGE_KEY);

  return value === 'client' || value === 'management' || value === 'admin'
    ? value
    : null;
}

export function setImpersonationOrigin(
  origin: ImpersonationOrigin,
  storage?: Storage
): void {
  getStorage(storage)?.setItem(IMPERSONATION_ORIGIN_STORAGE_KEY, origin);
}

export function setClientImpersonationOrigin(storage?: Storage): void {
  const activeStorage = getStorage(storage);

  if (!activeStorage) {
    return;
  }

  const existingOrigin = getImpersonationOrigin(activeStorage);

  if (existingOrigin === 'admin' || existingOrigin === 'management') {
    return;
  }

  // An active session without an origin may be a legacy admin or management
  // session. Keep it unknown so nested impersonation cannot enable client exit.
  if (existingOrigin === null && activeStorage.getItem('impersination') === 'yes') {
    return;
  }

  setImpersonationOrigin('client', activeStorage);
}

export function canExitImpersonation(storage?: Storage): boolean {
  const activeStorage = getStorage(storage);

  return activeStorage?.getItem('impersination') === 'yes'
    && getImpersonationOrigin(activeStorage) === 'client';
}

export function clearImpersonationOrigin(storage?: Storage): void {
  getStorage(storage)?.removeItem(IMPERSONATION_ORIGIN_STORAGE_KEY);
}
